import React from 'react';
import { styled, alpha } from '@mui/material/styles';
import BootstrapContainer from './BootstrapContainer';

const UnstyledFooter = (props: {}) => {
  return (
    <footer id="footer" {...props}>
      <div id="copyrights" className="hide-on-print">
        <BootstrapContainer>
          <div className="row justify-content-center">
            <div className="col-md-6 align-self-center">
              Copyrights &copy; 2023-2024 MiTAC Computing Technology Corporation
              (MiTAC Group). All Rights Reserved.
              <br />
              For optimal viewing, please use the most recent version of a
              modern browser like Firefox or Chrome.
              <div
                style={{
                  fontSize: '0.5rem',
                  color: '#557995',
                  lineHeight: '0.7rem',
                  fontStyle: 'italic',
                }}
              >
                On April 6, 2023, Mitac acquired a license to manufacture
                certain Intel server boards. During a transitionary period,
                Mitac will continue to manufacture and sell certain Intel
                branded server boards with Mitac-branded products. All questions
                and product support requests should be directed to
                DSGsales@mitac.com.
              </div>
            </div>

            <div className="col-md-6 align-self-center">
              <div className="copyrights-menu text-end copyright-links m-0">
                <a
                  href="https://www.mitaccomputing.com/EN/about_mitac/"
                  target="mct-1"
                >
                  About MiTAC
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.mitaccomputing.com/EN/legal/terms_of_use/"
                  target="mct-1"
                >
                  Terms of Use
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.mitaccomputing.com/EN/legal/privacy_policy/"
                  target="mct-1"
                >
                  Privacy Policy
                </a>
                &nbsp;|&nbsp;
                <a
                  href="https://www.mitaccomputing.com/EN/legal/cookie_policy/"
                  target="mct-1"
                >
                  Cookie Policy
                </a>
                &nbsp;|&nbsp;
                <a href="https://www.mitaccomputing.com/contact">Contact Us</a>
              </div>
            </div>
          </div>
        </BootstrapContainer>
      </div>
    </footer>
  );
};

const Footer = styled(UnstyledFooter)(({ theme }) => ({
  backgroundColor: '#1F2024',
  borderTop: `5px solid ${alpha(theme.palette.common.white, 0.15)}`,

  '@media print': {
    borderTop: 'none',
    '.hide-on-print': {
      display: 'none',
    },
  },

  '#copyrights': {
    color: alpha(theme.palette.common.white, 0.4),
    backgroundColor: alpha(theme.palette.common.black, 0.2),
    padding: '2.5rem 0',
    fontSize: '0.875rem',
    lineHeight: 1.65,
  },

  '.justify-content-center': {
    justifyContent: 'center',
  },

  '.align-self-center': {
    alignSelf: 'center',
  },

  '.text-end': {
    textAlign: 'right',
  },

  '.row': {
    display: 'flex',
    flexWrap: 'wrap',
    marginRight: '-0.75rem',
    marginLeft: '-0.75rem',
  },
  '.row > *': {
    flexShrink: 0,
    width: '100%',
    maxWidth: '100%',
    paddingRight: '0.75rem',
    paddingLeft: '0.75rem',
  },

  '.col-md-6': {
    flex: '0 0 auto',
    width: '50%',
  },

  '.copyright-links': {
    color: '#adb5bd',

    '& a': {
      color: '#adb5bd',
      display: 'inline-block',
      fontSize: '0.875rem',
      margin: '0 10px',
    },
    '& a:first-of-type': {
      marginLeft: 0,
    },
    '& a:last-of-type': {
      marginRight: 0,
    },
  },
}));

export default Footer;
